import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "textframepreference"
    }}>{`TextFramePreference`}</h1>
    <p>{`Text frame preferences.`}</p>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the TextFramePreference (a Application, Document, TextFrame, EndnoteTextFrame or ObjectStyle).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`textColumnCount`}</strong>{` `}</p>
      <p parentName="blockquote">{`The number of columns in the text frame. Note: Depending on the value of use fixed column width, the number of columns can change automatically when the text frame size changes.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`textColumnGutter`}</strong>{` `}</p>
      <p parentName="blockquote">{`The space between columns in the text frame.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`textColumnFixedWidth`}</strong>{` `}</p>
      <p parentName="blockquote">{`The column width of the columns in the text frame.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`useFixedColumnWidth`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, maintains column width when the text frame is resized. If false, causes columns to resize when the text frame is resized. Note: When true, resizing the frame can change the number of columns in the frame.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`insetSpacing`}</strong>{` `}</p>
      <p parentName="blockquote">{`The amount to offset text from the edges of the text frame, specified either as a single value applied uniformly to all sides of the text frame or as an array of 4 values in the format `}{`[top inset, left inset, bottom inset, right inset]`}{`. Can return: Unit (0 - 8640 points) or Array of 4 Units (0 - 8640 points).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`FirstBaseline `}<strong parentName="p">{`firstBaselineOffset`}</strong>{` `}</p>
      <p parentName="blockquote">{`The distance between the baseline of the text and the top inset of the text frame or cell.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`minimumFirstBaselineOffset`}</strong>{` `}</p>
      <p parentName="blockquote">{`The minimum distance between the baseline of the text and the top inset of the text frame or cell.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`VerticalJustification `}<strong parentName="p">{`verticalJustification`}</strong>{` `}</p>
      <p parentName="blockquote">{`The vertical alignment of the text content.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`verticalThreshold`}</strong>{` `}</p>
      <p parentName="blockquote">{`The maximum amount of vertical space between two paragraphs. Note: Valid only when vertical justification is justified; the specified amount is applied in addition to the space before or space after values defined for the paragraph.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`ignoreWrap`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, ignores text wrap settings for drawn or placed objects in the text frame.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`useFlexibleColumnWidth`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, maintains column width between a min and max range when the text frame is resized. If false, causes columns to resize when the text frame is resized. Note: When true, resizing the frame can change the number of columns in the frame.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`textColumnMaxWidth`}</strong>{` `}</p>
      <p parentName="blockquote">{`The maximum column width of the columns in the text frame. Use 0 to indicate no upper limit.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`AutoSizingTypeEnum `}<strong parentName="p">{`autoSizingType`}</strong>{` `}</p>
      <p parentName="blockquote">{`Auto-sizing type of text frame. Based on type, reference value is automatically adjusted. For example, for height only type, top-left reference point becomes top-center. Recommended to change auto-sizing type, after setting other auto-sizing attributes`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`AutoSizingReferenceEnum `}<strong parentName="p">{`autoSizingReferencePoint`}</strong>{` `}</p>
      <p parentName="blockquote">{`The reference point for auto sizing of text frame. Reference point is automatically adjusted to the suitable value depending on the auto-sizing type value. As an example, top left reference point becomes top center for height only dimension`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`useMinimumHeightForAutoSizing`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, minimum height value is used during the auto-sizing of text frame.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`minimumHeightForAutoSizing`}</strong>{` `}</p>
      <p parentName="blockquote">{`The minimum height for auto-sizing of the text frame.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`useMinimumWidthForAutoSizing`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, minimum width value is used during the auto-sizing of text frame.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`minimumWidthForAutoSizing`}</strong>{` `}</p>
      <p parentName="blockquote">{`The minimum width for auto-sizing of the text frame.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`useNoLineBreaksForAutoSizing`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, line-breaks are not introduced after auto sizing.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`columnRuleOverride`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, enable overrides to text frame vertical column rule options.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`columnRuleOffset`}</strong>{` `}</p>
      <p parentName="blockquote">{`Text Frame Column Rule Offset`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`columnRuleTopInset`}</strong>{` `}</p>
      <p parentName="blockquote">{`Text Frame Column Rule top inset`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`columnRuleInsetChainOverride`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, enable inset chain override.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`columnRuleBottomInset`}</strong>{` `}</p>
      <p parentName="blockquote">{`Text Frame Column Rule Bottom Inset`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`columnRuleStrokeWidth`}</strong>{` `}</p>
      <p parentName="blockquote">{`Text Frame Column Rule Width`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Swatch `}<strong parentName="p">{`columnRuleStrokeColor`}</strong>{` `}</p>
      <p parentName="blockquote">{`Text Frame Column Rule Stroke Color`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`StrokeStyle `}<strong parentName="p">{`columnRuleStrokeType`}</strong>{` `}</p>
      <p parentName="blockquote">{`Text Frame Column Rule Stroke Type`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`columnRuleStrokeTint`}</strong>{` `}</p>
      <p parentName="blockquote">{`Text Frame Column Rule Stroke Tint`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`columnRuleOverprintOverride`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, enable overprint override.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`footnotesEnableOverrides`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, enable overrides to document footnote options.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`footnotesSpanAcrossColumns`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, enable straddling footnotes.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`footnotesMinimumSpacing`}</strong>{` `}</p>
      <p parentName="blockquote">{`Minimum Spacing Before First Footnote`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`footnotesSpaceBetween`}</strong>{` `}</p>
      <p parentName="blockquote">{`Space between footnotes.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`verticalBalanceColumns`}</strong>{` `}</p>
      <p parentName="blockquote">{`Vertically justify balanced across all columns.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the TextFramePreference.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`TextFramePreference `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      